import { layerType } from "@/models/Layers.model";

export default {
  /**
   * Returns an aggregated object with all the layers structured as a computed layer or
   * part of an entity model collection
   * @param {Object} state
   */
  getLayers: state => {
    if (state.layerRegistry && state.layerRegistry.length > 0) {
      // loop through the layer registry
      return state.layerRegistry.map(layer => {
        // if the layer is a computed property, find the details from the computed layers list
        if (layer.type === layerType.COMPUTED_PROP) {
          return state.computedLayers.find(cLayer => cLayer.id === layer.id);
        }
        // else, if the layer type is an entity model, find all the properties of the entity model
        // from the entity props list
        else if (layer.type === layerType.ENTITY_MODEL) {
          // fetch the entity model details from the entity model list
          const entityModel = state.entityModels.find(
            models => models.id === layer.id
          );
          if (entityModel) {
            // attach all the layers as a layers property of the particular model
            return {
              ...entityModel,
              layers: state.entityProps.filter(
                item => item.entity_model_id === entityModel.id
              ),
            };
          }
          return entityModel;
        }
      });
    }
  },
  /**
   * Returns all the available properties in all entity models
   * @param {Object} state
   */
  getProperties: state => {
    const allProperties = [];
    state.layerRegistry
      .filter(item => item.type === layerType.ENTITY_MODEL)
      .forEach(model => {
        // get details of the entity model
        const entityModel = state.entityModels.find(
          item => item.id === model.id
        );
        // get all the properties of the entity model
        const props = state.entityProps
          .filter(item => item.entity_model_id === model.id)
          .map(item => {
            return {
              ...item,
              entity_model_name: entityModel.name, // add the entity model name to all props
            };
          });
        // add all the props into the array
        allProperties.push(...props);
      });
    return allProperties;
  },

  /**
   * Returns the active entity model
   * @param {*} state
   */
  getActiveEntity: state => {
    if (!(state.activeLayers && state.activeLayers.length > 0)) return null;
    const activePrimaryLayer = state.activeLayers.find(
      item => item.type === "primary"
    );
    if (!activePrimaryLayer) return null; // return if there is no active layer
    const layer = state.entityProps.find(
      item => item.id === activePrimaryLayer.id
    );
    if (!layer) return null; // if there is no layer prop return null
    const entityModel = state.entityModels.find(
      item => item.id === layer.entity_model_id
    );
    if (!entityModel) return null; // if there is no entity model associated, return null
    // return the layer and entity model
    return {
      layer,
      entityModel,
    };
  },
  /**
   * Returns the list of currently active layers
   */
  getActiveLayers: state => {
    return state.activeLayers;
  },
  /**
   * Returns the list of all static layers
   */
  getStaticLayers: state => {
    return state.staticLayers.map(item => {
      return {
        id: item.id,
        name: item.name,
        isActive: state.activeStaticLayers.includes(item.id),
      };
    });
  },
  getActiveStaticLayers: state => {
    return state.staticLayers.filter(item =>
      state.activeStaticLayers.includes(item.id)
    );
  },
};
